import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Table } from 'reactstrap';

const BulkAssignmentReport = ({ isOpen, results = [], onClose }) => (
  <Modal isOpen={isOpen} size="lg" scrollable className="bulk-assignment-report">
    <ModalHeader>Bulk Assignment Report</ModalHeader>
    <ModalBody>
      <Table responsive>
        <thead>
          <tr>
            <th>Phone Number / DID</th>
            <th>Result</th>
            <th>Assigned Company</th>
            <th>Failure Reason</th>
          </tr>
        </thead>
        <tbody>
          {results.map(row => (
            <tr key={row.numberId || row.number}>
              <td>{row.number || '-'}</td>
              <td className={row.result === 'Success' ? 'assignment-result-success' : 'assignment-result-failed'}>
                {row.result}
              </td>
              <td>{row.assignedCompany || '-'}</td>
              <td>{row.failureReason || '-'}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </ModalBody>
    <ModalFooter>
      <Button color="primary" onClick={onClose}>
        Close
      </Button>
    </ModalFooter>
  </Modal>
);

export default BulkAssignmentReport;
